import React, { CSSProperties, useEffect, useState } from "react";
import queryString from "query-string";
import "./App.css";
import { TVChartContainer } from "./components/TVChartContainer/index";

const values = queryString.parse(window.location.search);

var symbol = values.symbol ? values.symbol : "AAPL";
var interval = values.interval ? values.interval : "1";
var isMobile = values.isMobile ? values.isMobile : false;

const App = () => {
  return (
    <TVChartContainer
      symbol={symbol}
      isMobile={isMobile}
      interval={interval}
      fullscreen={window.innerWidth < 768}
    />
  );
};

export default App;
